import {
  ArtificialEventTypeEnum,
  HiddenEventTypeEnum,
  BehaviorNameEnum,
  EventTypeEnum,
  EventType,
  BehaviorName,
} from '@hotjar/webapp/features/Playbacks/types';
import type { ActionFilter } from './types';

export const PADDING_SIZE = 20;
export const ITEM_SIZE = 52;
export const EXTRA_OFFSET_SIZE = 3 * ITEM_SIZE;

export const ACTION_FILTERS: {
  [key in ActionFilter]: {
    label: string;
    actions: Array<EventType | BehaviorName>;
  };
} = {
  [EventTypeEnum.MOUSE_CLICK]: {
    label: 'common:player.actions-list.action-type.mouse-click',
    actions: [EventTypeEnum.MOUSE_CLICK],
  },
  [EventTypeEnum.TAG_RECORDING]: {
    label: 'common:player.actions-list.action-type.tag-recording',
    actions: [EventTypeEnum.TAG_RECORDING],
  },
  [BehaviorNameEnum.FEEDBACK]: {
    label: 'common:player.actions-list.action-type.feedback',
    actions: [BehaviorNameEnum.FEEDBACK],
  },
  [EventTypeEnum.PAGE]: {
    label: 'common:player.actions-list.action-type.page',
    actions: [EventTypeEnum.PAGE],
  },
  [BehaviorNameEnum.RAGE_CLICK]: {
    label: 'common:player.actions-list.action-type.rageclick',
    actions: [BehaviorNameEnum.RAGE_CLICK],
  },

  [ArtificialEventTypeEnum.SELECTION]: {
    label: 'common:player.actions-list.action-type.selection',
    actions: [HiddenEventTypeEnum.INPUT_CHOICE_CHANGE, HiddenEventTypeEnum.SELECT_CHANGE],
  },
  [BehaviorNameEnum.POLL]: {
    label: 'common:player.actions-list.action-type.poll',
    actions: [BehaviorNameEnum.POLL],
  },

  [EventTypeEnum.KEY_PRESS]: {
    label: 'common:player.actions-list.action-type.key-press',
    actions: [EventTypeEnum.KEY_PRESS],
  },
  [BehaviorNameEnum.U_TURN]: {
    label: 'common:player.actions-list.action-type.uturn',
    actions: [BehaviorNameEnum.U_TURN],
  },
  [EventTypeEnum.VIEWPORT_RESIZE]: {
    label: 'common:player.actions-list.action-type.viewport-resize',
    actions: [EventTypeEnum.VIEWPORT_RESIZE],
  },
};

export const ACTION_FILTER_OPTIONS = (Object.keys(ACTION_FILTERS) as ActionFilter[]).map((key) => ({
  value: key,
  label: (ACTION_FILTERS[key] as { label: string }).label as string,
}));
